import { SiriusBaseComponent } from 'sirius-framework';
import { Input, Output, EventEmitter, Component, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonService } from '../../shared/service/shared.service';

/** String resource — boşsa Türkçe varsayılan */
const MESSAGE_SHOW_KEYS = {
  btnTamam: 'yediEminMessageShowBtnTamam',
  btnIptal: 'yediEminMessageShowBtnIptal',
};

@Component({
  selector: 'message-show',
  templateUrl: './message-show.component.html',
  styleUrls: ['./message-show.component.css']
})
export class MessageShowComponent extends SiriusBaseComponent<any> {
  @Input('MessageTitle') messageTitle: string;
  @Input('Message') message: string;
  @Output('OnMessageAccepted') onMessageAccepted = new EventEmitter<void>();
  @Input('ShowCancelButton') showCancelButton: boolean;

  @ViewChild("template") template: TemplateRef<any>;

  modalRef: BsModalRef;
  btnTamam = 'Tamam';
  btnIptal = 'İptal';

  constructor(private modalService: BsModalService, private commonService: CommonService) {
    super();
  }

  OnInit() {
    this.loadMessageShowResourceStrings();
  }

  private loadMessageShowResourceStrings(): void {
    const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);
    this.btnTamam = r(MESSAGE_SHOW_KEYS.btnTamam, this.btnTamam);
    this.btnIptal = r(MESSAGE_SHOW_KEYS.btnIptal, this.btnIptal);
  }

  openModal() {
    this.modalRef = this.modalService.show(this.template);
  }

  onAccept() {
    this.onMessageAccepted.emit();
    this.close();
  }
  showPopup() {
    this.openModal();
  }

  close() {
    this.modalRef.hide();
  }

}
